// extracted by mini-css-extract-plugin
export default {"warning":"x7B2OVLqybjGMYWda8jt","error":"vPcq1Qm05drOvmNSS9dL","neutral":"JQIpODX1B4MEYKLFhGM5"};